import { ReactElement } from 'react';
import styles from './task-features-icons.module.scss';
import { UIText, UITooltip } from '@/ui';
import { useCompaniesTranslation } from '../hooks';

type TaskFeaturesIconsProps = {
    pin: boolean;
    arc: boolean;
};
export function TaskFeaturesIcons(props: TaskFeaturesIconsProps): ReactElement {
    const { pin, arc } = props;

    const { t } = useCompaniesTranslation();
    const pinString = t('components.task_features_icons.tooltip_pin');
    const arcString = t('components.task_features_icons.tooltip_arc');

    const hasFeatures = pin || arc;

    if (!hasFeatures) {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 2
                }}
            >
                <UIText type="default2">{t('shared.labels.none')}</UIText>
            </div>
        );
    }

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: 4
            }}
        >
            {arc && (
                <div className={styles.featureIconContainer}>
                    <UITooltip text={arcString}>
                        <div className={styles.featureLabel}>24/7</div>
                    </UITooltip>
                </div>
            )}

            {pin && (
                <div className={styles.featureIconContainer}>
                    <UITooltip text={pinString}>
                        <div
                            className={`${styles.featureLabel} ${styles.featureLabelPin}`}
                        >
                            {t('components.teams_list.filter_pin')}
                        </div>
                    </UITooltip>
                </div>
            )}
        </div>
    );
}
